import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5e37ccc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  rel: "stylesheet",
  href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
}, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "container w-auto"
}
const _hoisted_3 = { class: "control-group mb-4" }
const _hoisted_4 = { class: "button-group toolbar flex flex-wrap gap-2 bg-gray-100 p-2 rounded-md shadow border border-gray-200" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bold" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-italic" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-strikethrough" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list-ul" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list-ol" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-quote-right" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-youtube" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-image" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "p-4" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-semibold mb-2 block" }, "Enter Link URL:", -1))
const _hoisted_28 = { class: "modal-buttons" }
const _hoisted_29 = { class: "p-4" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-semibold mb-2 block" }, "Enter Youtube Link:", -1))
const _hoisted_31 = { class: "modal-buttons" }
const _hoisted_32 = { class: "p-4" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-semibold mb-2 block" }, "Upload Image:", -1))
const _hoisted_34 = { class: "modal-buttons" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-align-left" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-align-center" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-align-right" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo" }, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = ["disabled"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo" }, null, -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "w-[445px] h-[503px] flex flex-col" }
const _hoisted_48 = { class: "flex items-center justify-between px-4 py-3 flex-shrink-0" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-base leading-6 text-gray-900" }, "Select Listings to Add", -1))
const _hoisted_50 = { class: "flex-1 px-4 py-3 overflow-hidden relative" }
const _hoisted_51 = { class: "relative mb-4" }
const _hoisted_52 = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }
const _hoisted_53 = {
  key: 0,
  class: "flex items-center justify-center h-full"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin text-primary-color-600 text-3xl" }, null, -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  key: 1,
  class: "absolute inset-0 flex items-center justify-center",
  style: {"top":"30px","pointer-events":"none"}
}
const _hoisted_57 = {
  class: "text-center",
  style: {"pointer-events":"auto"}
}
const _hoisted_58 = { class: "text-gray-500 text-sm" }
const _hoisted_59 = {
  key: 2,
  class: "h-full flex flex-col"
}
const _hoisted_60 = { class: "flex-1 overflow-y-auto" }
const _hoisted_61 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["src", "onError"]
const _hoisted_64 = { class: "flex-1 min-w-0" }
const _hoisted_65 = { class: "font-semibold text-base leading-6 text-gray-900" }
const _hoisted_66 = { class: "text-gray-900 text-sm leading-5 font-normal" }
const _hoisted_67 = { class: "flex items-center gap-2 text-gray-900" }
const _hoisted_68 = { class: "text-sm leading-5" }
const _hoisted_69 = { class: "font-semibold" }
const _hoisted_70 = { class: "text-sm leading-5" }
const _hoisted_71 = { class: "font-semibold" }
const _hoisted_72 = { class: "text-sm leading-5" }
const _hoisted_73 = { class: "font-semibold" }
const _hoisted_74 = { class: "flex items-center gap-2 text-sm text-gray-900" }
const _hoisted_75 = { class: "flex items-center gap-1" }
const _hoisted_76 = { class: "text-sm leading-5 font-normal" }
const _hoisted_77 = { class: "flex items-center gap-1" }
const _hoisted_78 = { class: "text-sm leading-5 font-normal" }
const _hoisted_79 = { class: "flex items-center gap-1" }
const _hoisted_80 = { class: "text-sm leading-5 font-normal" }
const _hoisted_81 = { class: "bg-gray-50 px-4 py-3 flex-shrink-0 rounded-b-lg" }
const _hoisted_82 = { class: "flex justify-end gap-x-3" }

import { ref, onMounted, watch, computed, onUnmounted } from "vue"

// Import Tiptap Editor and Extensions
import { Editor, EditorContent } from "@tiptap/vue-3"
import { Color } from "@tiptap/extension-color"
import ListItem from "@tiptap/extension-list-item"
import Placeholder from "@tiptap/extension-placeholder"
import TextStyle from "@tiptap/extension-text-style"
import StarterKit from "@tiptap/starter-kit"
import TextAlign from "@tiptap/extension-text-align"
import Link from "@tiptap/extension-link"
import ResizableImage from "@/components/rich-editor-extensions/ResizableImage"
import Youtube from "@tiptap/extension-youtube"
import ListingsBlock from "@/components/rich-editor-extensions/ListingsBlock"

// Import Table Extensions
import Table from "@tiptap/extension-table"
import TableRow from "@tiptap/extension-table-row"
import TableCell from "@tiptap/extension-table-cell"
import TableHeader from "@tiptap/extension-table-header"

// Import PrimeVue Components
import OverlayPanel from "primevue/overlaypanel"

// Import Heroicons
import {
    OfficeBuildingIcon,
    DocumentTextIcon,
    EyeIcon,
    BookmarkIcon,
    SearchIcon,
    HeartIcon,
    EyeOffIcon,
} from "@heroicons/vue/outline"

// Import Stores
import { useListingStore } from "@/stores/listings"
import { useContactListingStore } from "@/stores/contact-listings"
import { useAgencyStore } from "@/stores/agency"

// Import Custom Components
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsMergeFields from "@/components/GgmsMergeFields.vue"
import GgmsDropdown from "@/components/GgmsDropdown.vue"
import GgmsButton from "@/components/GgmsButton.vue"

// Import Models
import { Listing } from "@/shared/models/listing"
import GgmsSeparator from "@/components/GgmsSeparator.vue"
import { numberWithCommas, debounce, handleImageError } from "@/shared/utils/helpers"

// Filter media to only show photos

export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsRichTextEditor',
  props: {
    modelValue: {
        type: String,
        default: "",
    },
    errorMessage: {
        type: String,
        default: "",
    },
    placeholder: {
        type: String,
        default: "Write your email here...",
    },
    resetTrigger: {
        type: Number,
        default: 0,
    },
},
  emits: ["update:modelValue", "disableValidationError"],
  setup(__props, { emit: __emit }) {

const getValidPhotos = (media: any[]) => {
    if (!media || !Array.isArray(media)) return []
    return media.filter((m) => m.mediaCategory === "Photo")
}

const props = __props

const emit = __emit

const listingsStore = useListingStore()
const contactListingsStore = useContactListingStore()
const agencyStore = useAgencyStore()

const editor = ref<Editor | null>(null)
const linkUrl = ref<string>("")
const videoUrl = ref<string>("")
const body = ref<string>(props.modelValue)

// sort by
const sortBy = ref<string>("")
const sortOptions = ref([
    { label: "Total Views", value: "totalViews" },
    { label: "Recently Viewed", value: "recentlyViewed" },
    { label: "Recently Saved", value: "recentlySaved" },
])
// listings
const selectedListings = ref<Listing[]>([])
const selectedListingIds = ref<Set<string>>(new Set())
const searchQuery = ref<string>("")

// merge fields
const specialVariable = ref("")

// Computed properties
const listings = computed(() => listingsStore.tableState.data)

// Refs for OverlayPanels
const linkPanel = ref<OverlayPanel | null>(null)
const videoPanel = ref<OverlayPanel | null>(null)
const imagePanel = ref<OverlayPanel | null>(null)
const listingsPanel = ref<OverlayPanel | null>(null)

// Agency
const agency = computed(() => agencyStore.selectedAgency)

// Loading
const isLoading = ref<boolean>(false)

// Computed property for button text based on selection state
const buttonText = computed(() => {
    const hasExistingListings = getAllListingsFromEditor().length > 0
    const hasSelectedListings = selectedListings.value.length > 0

    if (!hasSelectedListings && hasExistingListings) {
        return "Delete Block"
    } else if (hasSelectedListings && hasExistingListings) {
        return "Update Listings"
    } else {
        return "Add Listings"
    }
})

// Computed property to determine if a listing is selected based on its ID
const isListingSelected = (listing: Listing): boolean => {
    return selectedListingIds.value.has(listing.listingId)
}

// Function to extract all listings from existing blocks in the editor
function getAllListingsFromEditor(): Listing[] {
    if (!editor.value) return []

    const allListings: Listing[] = []
    const editorJSON = editor.value.getJSON()

    // Recursively search for listings blocks in the editor content
    function searchForListingsBlocks(content: any): void {
        if (Array.isArray(content)) {
            content.forEach(searchForListingsBlocks)
        } else if (content && typeof content === "object") {
            if (content.type === "listingsBlock" && content.attrs?.listings) {
                allListings.push(...content.attrs.listings)
            }
            if (content.content) {
                searchForListingsBlocks(content.content)
            }
        }
    }

    searchForListingsBlocks(editorJSON.content)
    return allListings
}

// Function to pre-select existing listings in the overlay
function preselectExistingListings(existingListings: Listing[]): void {
    if (existingListings.length === 0) return

    // Clear current selections
    selectedListingIds.value.clear()
    selectedListings.value = []

    // Add existing listings to selection
    existingListings.forEach((listing: Listing) => {
        selectedListingIds.value.add(listing.listingId)
        selectedListings.value.push(listing)
    })
}

function openListingsPanel(event: Event) {
    // Get all existing listings from blocks in the editor
    const existingListings = getAllListingsFromEditor()

    // Pre-select existing listings in the overlay
    preselectExistingListings(existingListings)

    listingsPanel.value?.toggle(event)
}

const isMergeFieldsModalOpen = ref(false)

function openMergeFieldsModal() {
    specialVariable.value = ""
    isMergeFieldsModalOpen.value = true
}

function closeMergeFieldsModal() {
    isMergeFieldsModalOpen.value = false
}

// Helper function to remove listings blocks from content
function removeListingsBlocks(content: any): any {
    if (Array.isArray(content)) {
        return content.map(removeListingsBlocks).filter((item) => item !== null)
    } else if (content && typeof content === "object") {
        if (content.type === "listingsBlock") {
            return null // Remove this block
        }
        if (content.content) {
            content.content = removeListingsBlocks(content.content)
        }
        return content
    }
    return content
}

function confirmListings() {
    const editorInstance = editor.value
    const hasExistingListings = getAllListingsFromEditor().length > 0
    const hasSelectedListings = selectedListings.value.length > 0

    if (!editorInstance) return

    // If no listings selected and there are existing listings, delete the block
    if (!hasSelectedListings && hasExistingListings) {
        // Find and delete existing listings blocks
        const editorJSON = editorInstance.getJSON()
        const updatedContent = removeListingsBlocks(editorJSON.content)
        editorInstance.commands.setContent({ type: "doc", content: updatedContent })

        resetSearchAndClosePanel()
        return
    }

    // If there are selected listings, insert or update the block
    if (hasSelectedListings) {
        // If there are existing listings, we need to replace them
        if (hasExistingListings) {
            // Remove existing blocks first
            const editorJSON = editorInstance.getJSON()
            const updatedContent = removeListingsBlocks(editorJSON.content)
            editorInstance.commands.setContent({ type: "doc", content: updatedContent })
        }

        // Insert the new listings block
        editorInstance.chain().focus().insertListingsBlock(selectedListings.value).run()
        resetSearchAndClosePanel()
    }
}

// Helper function to reset search and close panel
async function resetSearchAndClosePanel() {
    // Close panel - the closeOverlayPanel function will handle search reset if needed
    closeOverlayPanel("listingsPanel")
}

// Function to toggle listing selection
function toggleListingSelection(index: number) {
    const listing = listings.value[index]
    const isCurrentlySelected = selectedListingIds.value.has(listing.listingId)

    if (isCurrentlySelected) {
        // Remove from selection
        selectedListingIds.value.delete(listing.listingId)
        selectedListings.value = selectedListings.value.filter((item) => item.listingId !== listing.listingId)
    } else {
        // Add to selection
        selectedListingIds.value.add(listing.listingId)
        selectedListings.value.push(listing)
    }
}

// Update selected listings when checkboxes change
function updateSelectedListings(index: number) {
    toggleListingSelection(index)
}

// Search functionality
async function performSearch() {
    try {
        isLoading.value = true
        // Set the search value in the table state
        listingsStore.tableState.search = searchQuery.value
        listingsStore.tableState.listingIdSearch = true
        await listingsStore.getAll()
        // Don't reset selected state when search results change - keep existing selections
    } catch (error) {
        console.error("Error searching listings:", error)
    } finally {
        listingsStore.tableState.listingIdSearch = false
        isLoading.value = false
    }
}

// Debounced search function - waits 300ms after user stops typing
const debouncedSearch = debounce(performSearch, 300)

function onSearchInput() {
    // Call the debounced search function
    debouncedSearch()
}

async function clearSearch() {
    searchQuery.value = ""
    listingsStore.tableState.search = ""
    try {
        isLoading.value = true
        // Keep the current sortBy when clearing search
        listingsStore.tableState.sortBy = sortBy.value || undefined
        await listingsStore.getAll()
        // Don't reset selected state when clearing search - keep existing selections
    } catch (error) {
        console.error("Error clearing search:", error)
    } finally {
        isLoading.value = false
    }
}

// Watch for sortBy changes
watch(sortBy, async (newSortBy) => {
    try {
        isLoading.value = true
        listingsStore.tableState.sortBy = newSortBy || undefined
        await listingsStore.getAll()
        // Don't reset selected state when sort changes - keep existing selections
    } catch (error) {
        console.error("Error sorting listings:", error)
    } finally {
        isLoading.value = false
    }
})

function addMergeFieldToTextMessage(mergeField: string) {
    if (editor.value) {
        editor.value.chain().focus().insertContent(mergeField).run()
    }
}

// Synchronize body with parent component
watch(body, (newValue) => {
    emit("update:modelValue", newValue)
})

// Watch for changes in props and update body accordingly
watch(
    () => props.modelValue,
    (newValue) => {
        if (newValue !== body.value) {
            body.value = newValue
            if (editor.value) {
                editor.value.commands.setContent(newValue)
            }
        }
    }
)

// Function to reset selected listings overlay
function resetListingsOverlay() {
    selectedListingIds.value.clear()
    selectedListings.value = []
}

// Watch for reset trigger changes
watch(
    () => props.resetTrigger,
    (newValue, oldValue) => {
        if (newValue !== oldValue && newValue > 0) {
            resetListingsOverlay()
        }
    }
)

onUnmounted(() => {
    listingsStore.tableState.sortBy = ""
})

onMounted(async () => {
    try {
        isLoading.value = true
        editor.value = new Editor({
            content: body.value,
            extensions: [
                Color.configure({ types: [TextStyle.name, ListItem.name] }),
                TextStyle,
                StarterKit,
                Placeholder.configure({
                    placeholder: props.placeholder,
                }),
                TextAlign.configure({
                    types: ["heading", "paragraph"],
                }),
                Link.configure({
                    autolink: false,
                    openOnClick: true,
                }).extend({
                    inclusive: false,
                }),
                ResizableImage,
                Youtube.configure({
                    controls: true,
                    width: 640,
                    height: 480,
                    HTMLAttributes: {
                        class: "responsive-video",
                    },
                }),
                Table.configure({
                    resizable: true,
                }),
                TableRow,
                TableHeader,
                TableCell,
                ListingsBlock,
            ],
            editorProps: {
                handlePaste: (view, event) => {
                    const text = event.clipboardData?.getData("text/plain")
                    const isYoutube =
                        text?.startsWith("https://www.youtube.com/watch?v=") || text?.startsWith("https://youtu.be/")

                    // Check if the pasted text is a YouTube URL
                    if (text && isYoutube) {
                        event.preventDefault() // Prevent default paste behavior

                        // Format the URL for embedding
                        let formattedUrl = text
                        if (text.includes("youtube.com/watch?v=")) {
                            formattedUrl = text.replace("watch?v=", "embed/")
                        } else if (text.includes("youtu.be/")) {
                            const videoId = text.split("youtu.be/")[1]
                            formattedUrl = `https://www.youtube.com/embed/${videoId}`
                        }

                        // Insert video with paragraphs before and after
                        editor.value
                            ?.chain()
                            .focus()
                            .insertContent([
                                { type: "paragraph" },
                                {
                                    type: "youtube",
                                    attrs: {
                                        src: formattedUrl,
                                        class: "responsive-video",
                                    },
                                },
                                { type: "paragraph" },
                            ])
                            .run()

                        return true // Indicate that the paste was handled
                    }

                    // Check if the pasted text is a valid URL
                    const urlRegex = /^(https?:\/\/[^\s]+)$/
                    if (text && urlRegex.test(text) && !isYoutube) {
                        event.preventDefault() // Prevent the default paste behavior

                        // Insert the text as a clickable link
                        editor.value
                            ?.chain()
                            .focus()
                            .insertContent({
                                type: "text",
                                text: text,
                                marks: [
                                    {
                                        type: "link",
                                        attrs: {
                                            href: text,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                        },
                                    },
                                ],
                            })
                            .run()

                        return true // Indicate the paste event was handled
                    }

                    if (text && (text.startsWith("http://") || text.startsWith("https://"))) {
                        event.preventDefault() // Prevent the default behavior
                        editor.value?.chain().focus().insertContent(text).run() // Insert as plain text
                        return true // Indicate the paste event is handled
                    }

                    return false // Let the default behavior handle non-video content
                },
            },
            onUpdate: ({ editor }) => {
                const editorHTML = editor.getHTML()
                // Generate the actual email HTML with listings converted
                const emailHTML = generateEmailHTML(editorHTML)
                body.value = emailHTML

                // Check if all listings blocks have been deleted and clear selections if so
                const currentListings = getAllListingsFromEditor()
                if (currentListings.length === 0 && selectedListings.value.length > 0) {
                    // All listings blocks have been deleted, clear selections
                    selectedListingIds.value.clear()
                    selectedListings.value = []
                }
            },
        })
        if (listingsStore.tableState.data.length === 0) {
            await listingsStore.getAll()
        }

        // Initialize empty selections
        selectedListingIds.value.clear()
        selectedListings.value = []

        // Only prefill if the editor is empty and there are selected listings
        if (
            contactListingsStore.tableState.selectedData &&
            contactListingsStore.tableState.selectedData.length > 0 &&
            !body.value &&
            editor.value
        ) {
            editor.value.chain().focus().insertListingsBlock(contactListingsStore.tableState.selectedData).run()
        }
        if (
            listingsStore.tableState.selectedData &&
            listingsStore.tableState.selectedData.length > 0 &&
            !body.value &&
            editor.value
        ) {
            editor.value.chain().focus().insertListingsBlock(listingsStore.tableState.selectedData).run()
        }
    } finally {
        isLoading.value = false
    }
})

// Functions to open panels
function openLinkPanel(event: Event) {
    const { href } = editor.value?.getAttributes("link") || {}
    linkUrl.value = href ? href : ""
    linkPanel.value?.toggle(event)
}

function openVideoPanel(event: Event) {
    videoPanel.value?.toggle(event)
}

function openImagePanel(event: Event) {
    imagePanel.value?.toggle(event)
}

// Function to toggle blockquote
function toggleBlockquote() {
    if (editor.value) {
        if (editor.value.isActive("blockquote")) {
            editor.value.chain().focus().toggleBlockquote().run()
        } else {
            editor.value.chain().focus().toggleBlockquote().run()

            // Insert help text after a short delay to indicate how to exit
            setTimeout(() => {
                editor.value
                    ?.chain()
                    .focus()
                    .insertContent([
                        {
                            type: "paragraph",
                            content: [
                                {
                                    type: "text",
                                    text: "Tip: Press Enter twice to exit the quote. Delete this before sending the message.",
                                    marks: [{ type: "italic" }],
                                },
                            ],
                        },
                    ])
                    .run()
            }, 10)
        }
    }
}

// Function to close overlay panels
function closeOverlayPanel(panelName: string) {
    switch (panelName) {
        case "linkPanel":
            linkPanel.value?.hide()
            break
        case "videoPanel":
            videoPanel.value?.hide()
            break
        case "imagePanel":
            imagePanel.value?.hide()
            break
        case "listingsPanel":
            listingsPanel.value?.hide()
            // If there was a search active, reset it and reload listings
            if (searchQuery.value || listingsStore.tableState.search) {
                searchQuery.value = ""
                listingsStore.tableState.search = ""
                // Reload listings in the background
                listingsStore.getAll().catch((error) => {
                    console.error("Error reloading listings:", error)
                })
            }
            break
    }
}

// Function to confirm a link
function confirmLink() {
    if (linkUrl.value) {
        if (!linkUrl.value.startsWith("http://") && !linkUrl.value.startsWith("https://")) {
            linkUrl.value = `https://${linkUrl.value}`
        }
        if (editor.value?.isActive("link")) {
            editor.value.chain().focus().extendMarkRange("link").setLink({ href: linkUrl.value }).run()
        } else {
            editor.value?.chain().focus().setLink({ href: linkUrl.value }).run()
        }
        linkUrl.value = ""
        closeOverlayPanel("linkPanel")
    }
}

// Function to confirm a video embed
function confirmVideo() {
    if (videoUrl.value) {
        let videoId = ""

        if (videoUrl.value.includes("youtube.com/watch?v=")) {
            videoId = videoUrl.value.split("watch?v=")[1]
        } else if (videoUrl.value.includes("youtu.be/")) {
            videoId = videoUrl.value.split("youtu.be/")[1]
        }

        if (videoId) {
            // Format the URL for embedding in an iframe
            const embedUrl = `https://www.youtube.com/embed/${videoId}`

            // Insert the YouTube video as an iframe
            editor.value
                ?.chain()
                .focus()
                .insertContent([
                    { type: "paragraph" },
                    {
                        type: "youtube",
                        attrs: {
                            src: embedUrl,
                            width: 640,
                            height: 360,
                            controls: true,
                            allowfullscreen: true,
                        },
                    },
                    { type: "paragraph" },
                ])
                .run()
        }

        videoUrl.value = ""
        closeOverlayPanel("videoPanel")
    }
}

// Handle image upload
function handleImageUpload(event: Event) {
    const input = event.target as HTMLInputElement
    const file = input?.files ? input.files[0] : null
    if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
            const url = e.target?.result as string
            editor.value
                ?.chain()
                .focus()
                .insertContent([
                    { type: "paragraph" },
                    {
                        type: "image",
                        attrs: {
                            src: url,
                            width: 320,
                            height: 180,
                        },
                    },
                    { type: "paragraph" },
                ])
                .run()
        }
        reader.readAsDataURL(file)
        closeOverlayPanel("imagePanel")
    }
}

// Function to generate actual HTML email content from listings blocks
function generateEmailHTML(content: string): string {
    // Create a temporary div to parse the content
    const tempDiv = document.createElement("div")
    tempDiv.innerHTML = content

    // Find all listings blocks
    const listingsBlocks = tempDiv.querySelectorAll('[data-type="listings-block"]')

    listingsBlocks.forEach((block) => {
        const listingsData = block.getAttribute("data-listings")
        if (listingsData) {
            try {
                const listings = JSON.parse(listingsData)
                const emailHTML = generateListingsEmailHTML(listings)
                block.outerHTML = emailHTML
            } catch (error) {
                console.error("Error parsing listings data:", error)
            }
        }
    })

    return tempDiv.innerHTML
}

// Function to generate the actual email HTML for listings
function generateListingsEmailHTML(listings: any[]): string {
    // Helper function to get a value from listing or its attributes
    const getValue = (listing: any, key: string): string => {
        const val = listing[key] || listing.attributes?.[key] || ""
        return String(val)
    }

    let emailHTML = `
    <div style="max-width: 600px; margin: 20px auto; background-color: #ffffff; border-radius: 8px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); overflow: hidden; font-family: Arial, sans-serif;">

      <!-- Header -->
      <div style="text-align: center; padding: 30px 20px; background-color: #ffffff;">
        <h1 style="font-size: 2.5em; font-weight: bold; margin: 0 0 10px 0; color: #000;">Featured Properties</h1>
        <p style="color: #6c757d; margin: 0; font-size: 1em;">Discover your next home</p>
      </div>

      <!-- Properties -->`

    listings.forEach((listing) => {
        // Format the property link according to backend pattern
        const state = getValue(listing, "stateOrProvince")
        const city = getValue(listing, "city").replace(/\s+/g, "-")
        const address = getValue(listing, "unparsedAddress").replace(/,/g, "").replace(/\s+/g, "-").concat("-")
        const postalCode = getValue(listing, "postalCode")
        const listingId = getValue(listing, "listingId")
        const agencyDomain = "mergestack-com" // TODO: change to agency domain after CMS finished

        const propertyLink = `https://${agencyDomain}.site-dev.ggms.com/property-results/${state}/${city}/${address}${postalCode}/${listingId}/`

        // Get image URL with fallback
        const imageUrl =
            listing.media?.[0]?.mediaURL ||
            listing.attributes?.media?.[0]?.mediaURL ||
            require("@/assets/icons/no_image.png")

        // Format address line exactly like backend
        const addressLine = [
            getValue(listing, "streetNumber"),
            getValue(listing, "streetName"),
            getValue(listing, "streetSuffix"),
            listing.city,
            listing.stateOrProvince,
            getValue(listing, "postalCode"),
        ]
            .filter(Boolean)
            .join(" ")

        // Format price exactly like backend
        const formattedPrice = getValue(listing, "listPrice")
            ? `$${Number(getValue(listing, "listPrice")).toLocaleString()}`
            : listing.attributes?.listPrice
            ? `$${listing.attributes.listPrice.toLocaleString()}`
            : "Contact for Price"

        // Status styling exactly like backend
        const statusText = getValue(listing, "standardStatus") || "No Status"
        let statusColor = "#D1FAE5" // Light green
        let statusTextColor = "#065F46" // Dark green

        emailHTML += `
      <div style="margin: 20px; border: 2px solid #d1d5db; border-radius: 8px; overflow: hidden; background-color: #fff;">
        <div style="display: block; text-decoration: none; color: inherit;">
          <img src="${imageUrl}" alt="${addressLine}" style="width: 100%; height: 200px; object-fit: cover; display: block;">
          <div style="padding: 15px 20px;">
            <span style="display: inline-block; background-color: ${statusColor}; color: ${statusTextColor}; padding: 4px 8px; border-radius: 4px; font-size: 0.8em; margin-bottom: 10px; font-weight: 500;">
              ${statusText}
            </span>
            <div style="font-size: 1.5em; font-weight: bold; margin-bottom: 5px; color: #000;">
              ${formattedPrice}
            </div>
            <div style="font-size: 1em; color: #495057;">
              ${addressLine}
            </div>
            <div style="margin-top: 10px;">
              <a href="${propertyLink}" target="_blank" style="background-color: #17a2b8; color: #ffffff; padding: 8px 16px; border-radius: 4px; font-size: 0.9em; font-weight: 500; text-decoration: none; display: inline-block;">
                View Details
              </a>
            </div>
          </div>
        </div>
      </div>`
    })

    emailHTML += `
      <!-- Footer -->
      <div style="text-align: center; padding: 20px; border-top: 1px solid #e9ecef;">
        <div style="margin-bottom: 15px;">
          <div style="margin-bottom: 15px;">
            <a href="#" target="_blank" style="color: #6c757d; text-decoration: none; font-size: 0.9em;">Privacy policy</a>
            <span style="color: #6c757d; margin: 0 8px; font-size: 0.9em;">|</span>
            <a href="#" target="_blank" style="color: #6c757d; text-decoration: none; font-size: 0.9em;">Unsubscribe</a>
          </div>
        </div>
        <hr style="border: none; border-top: 1px solid #e9ecef; margin: 15px auto; width: 80%;">
        <div style="margin-bottom: 15px; font-weight: bold; color: #374151; font-size: 1em;">
          ${agency.value?.agencyName || "GGMS"}
        </div>
        <p style="margin: 0; color: #6c757d; font-size: 0.8em;">
          © ${new Date().getFullYear()} ${agency.value?.agencyName || "GGMS"}. All rights reserved.
        </p>
      </div>
    </div>`

    return emailHTML
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (editor.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (editor.value.chain().focus().toggleBold().run())),
                disabled: !editor.value.can().chain().focus().toggleBold().run(),
                class: _normalizeClass(['toolbar-button', editor.value.isActive('bold') ? 'active' : ''])
              }, _hoisted_7, 10, _hoisted_5),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (editor.value.chain().focus().toggleItalic().run())),
                disabled: !editor.value.can().chain().focus().toggleItalic().run(),
                class: _normalizeClass(['toolbar-button', editor.value.isActive('italic') ? 'active' : ''])
              }, _hoisted_10, 10, _hoisted_8),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (editor.value.chain().focus().toggleStrike().run())),
                disabled: !editor.value.can().chain().focus().toggleStrike().run(),
                class: _normalizeClass(['toolbar-button', editor.value.isActive('strike') ? 'active' : ''])
              }, _hoisted_13, 10, _hoisted_11),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (editor.value.chain().focus().toggleBulletList().run())),
                class: _normalizeClass(['toolbar-button', editor.value.isActive('bulletList') ? 'active' : ''])
              }, _hoisted_15, 2),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (editor.value.chain().focus().toggleOrderedList().run())),
                class: _normalizeClass(['toolbar-button', editor.value.isActive('orderedList') ? 'active' : ''])
              }, _hoisted_17, 2),
              _createElementVNode("button", {
                onClick: toggleBlockquote,
                class: _normalizeClass(['toolbar-button', editor.value.isActive('blockquote') ? 'active' : ''])
              }, _hoisted_19, 2),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (openLinkPanel($event))),
                class: "toolbar-button"
              }, _hoisted_21),
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (openVideoPanel($event))),
                class: "toolbar-button"
              }, _hoisted_23),
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (openImagePanel($event))),
                class: "toolbar-button"
              }, _hoisted_25),
              _createVNode(_unref(OverlayPanel), {
                ref_key: "linkPanel",
                ref: linkPanel,
                class: "border border-gray-300 shadow-md rounded-md"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((linkUrl).value = $event)),
                      type: "text",
                      class: "modal-input"
                    }, null, 512), [
                      [_vModelText, linkUrl.value]
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("button", {
                        onClick: confirmLink,
                        class: "modal-button primary-button w-full"
                      }, "Confirm"),
                      _createElementVNode("button", {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (closeOverlayPanel('linkPanel'))),
                        class: "modal-button secondary-button w-full"
                      }, " Cancel ")
                    ])
                  ])
                ]),
                _: 1
              }, 512),
              _createVNode(_unref(OverlayPanel), {
                ref_key: "videoPanel",
                ref: videoPanel,
                class: "border border-gray-300 shadow-md rounded-md"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((videoUrl).value = $event)),
                      type: "text",
                      class: "modal-input"
                    }, null, 512), [
                      [_vModelText, videoUrl.value]
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("button", {
                        onClick: confirmVideo,
                        class: "modal-button primary-button w-full"
                      }, "Confirm"),
                      _createElementVNode("button", {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (closeOverlayPanel('videoPanel'))),
                        class: "modal-button secondary-button w-full"
                      }, " Cancel ")
                    ])
                  ])
                ]),
                _: 1
              }, 512),
              _createVNode(_unref(OverlayPanel), {
                ref_key: "imagePanel",
                ref: imagePanel,
                class: "border border-gray-300 shadow-md rounded-md"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("input", {
                      type: "file",
                      onChange: handleImageUpload,
                      class: "modal-input"
                    }, null, 32),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("button", {
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (closeOverlayPanel('imagePanel'))),
                        class: "modal-button secondary-button w-full"
                      }, " Cancel ")
                    ])
                  ])
                ]),
                _: 1
              }, 512),
              _createElementVNode("button", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (editor.value.chain().focus().setTextAlign('left').run())),
                class: "toolbar-button"
              }, _hoisted_36),
              _createElementVNode("button", {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (editor.value.chain().focus().setTextAlign('center').run())),
                class: "toolbar-button"
              }, _hoisted_38),
              _createElementVNode("button", {
                onClick: _cache[15] || (_cache[15] = ($event: any) => (editor.value.chain().focus().setTextAlign('right').run())),
                class: "toolbar-button"
              }, _hoisted_40),
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = ($event: any) => (editor.value.chain().focus().undo().run())),
                disabled: !editor.value.can().chain().focus().undo().run(),
                class: "toolbar-button"
              }, _hoisted_43, 8, _hoisted_41),
              _createElementVNode("button", {
                onClick: _cache[17] || (_cache[17] = ($event: any) => (editor.value.chain().focus().redo().run())),
                disabled: !editor.value.can().chain().focus().redo().run(),
                class: "toolbar-button"
              }, _hoisted_46, 8, _hoisted_44),
              _createElementVNode("button", {
                onClick: _cache[18] || (_cache[18] = ($event: any) => (openListingsPanel($event))),
                class: "toolbar-button"
              }, [
                _createVNode(_unref(OfficeBuildingIcon), { class: "text-gray-500" })
              ]),
              _createVNode(_unref(OverlayPanel), {
                ref_key: "listingsPanel",
                ref: listingsPanel,
                class: "border border-gray-300 shadow-md rounded-md"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createVNode(GgmsDropdown, {
                        modelValue: sortBy.value,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((sortBy).value = $event)),
                        options: sortOptions.value,
                        placeholder: "Sort by",
                        optionLabel: "label",
                        optionValue: "value",
                        class: "border-0 rounded-md ring-0",
                        small: true,
                        isShowClear: true
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createVNode(GgmsSeparator, { class: "flex-shrink-0" }),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_unref(SearchIcon), { class: "h-5 w-5 text-gray-400" })
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((searchQuery).value = $event)),
                          type: "text",
                          placeholder: "Search by Listing ID...",
                          class: "block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-primary-color-500 focus:border-primary-color-500 sm:text-sm",
                          onInput: onSearchInput
                        }, null, 544), [
                          [_vModelText, searchQuery.value]
                        ])
                      ]),
                      (isLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55))
                        : (listings.value.length === 0 && searchQuery.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("p", _hoisted_58, "No listings found for \"" + _toDisplayString(searchQuery.value) + "\"", 1),
                                _createVNode(GgmsButton, {
                                  onClick: clearSearch,
                                  styleType: "secondary",
                                  class: "mt-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Clear search ")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listings.value, (listing, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: listing.listingId,
                                      class: "flex items-center gap-4 p-4 border rounded-lg hover:bg-gray-50 transition-shadow shadow-sm cursor-pointer",
                                      onClick: ($event: any) => (toggleListingSelection(index))
                                    }, [
                                      _createElementVNode("img", {
                                        src: 
                                                    getValidPhotos(listing?.attributes?.media).length > 0
                                                        ? getValidPhotos(listing.attributes?.media)[0].mediaURL
                                                        : require('@/assets/icons/no_image.png')
                                                ,
                                        alt: "Listing Image",
                                        class: "w-20 h-16 rounded-md object-cover flex-shrink-0",
                                        onError: 
                                                    (event) =>
                                                        _unref(handleImageError)(
                                                            event,
                                                            getValidPhotos(listing?.attributes?.media)
                                                        )
                                                
                                      }, null, 40, _hoisted_63),
                                      _createElementVNode("div", _hoisted_64, [
                                        _createElementVNode("h3", _hoisted_65, _toDisplayString(listing.listingId), 1),
                                        _createElementVNode("p", _hoisted_66, _toDisplayString(listing.attributes?.city || "Coventry") + ", " + _toDisplayString(listing.attributes?.country || "United Kingdom"), 1),
                                        _createElementVNode("div", _hoisted_67, [
                                          _createElementVNode("span", _hoisted_68, [
                                            _createElementVNode("span", _hoisted_69, _toDisplayString(listing.attributes?.bedroomsTotal ?? 0), 1),
                                            _createTextVNode(" beds")
                                          ]),
                                          _createElementVNode("span", _hoisted_70, [
                                            _createElementVNode("span", _hoisted_71, _toDisplayString(listing.attributes?.rawMlsBathroomsTotal ?? 0), 1),
                                            _createTextVNode(" baths")
                                          ]),
                                          _createElementVNode("span", _hoisted_72, [
                                            _createElementVNode("span", _hoisted_73, _toDisplayString(_unref(numberWithCommas)(
                                                                Number(listing.attributes?.lotSizeSquareFeet ?? 0)
                                                            )), 1),
                                            _createTextVNode(" sq.ft")
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_74, [
                                          _createElementVNode("div", _hoisted_75, [
                                            _createVNode(_unref(EyeIcon), { class: "w-4 h-4" }),
                                            _createElementVNode("span", _hoisted_76, _toDisplayString(listing.totalViewsCount ?? 0), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_77, [
                                            _createVNode(_unref(HeartIcon), { class: "w-4 h-4" }),
                                            _createElementVNode("span", _hoisted_78, _toDisplayString(listing.totalFavouritesCount ?? 0), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_79, [
                                            _createVNode(_unref(EyeOffIcon), { class: "w-4 h-4" }),
                                            _createElementVNode("span", _hoisted_80, _toDisplayString(listing.totalHiddenCount ?? 0), 1)
                                          ])
                                        ])
                                      ]),
                                      _createVNode(GgmsCheckBox, {
                                        modelValue: isListingSelected(listing),
                                        label: '',
                                        onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"])),
                                        "onUpdate:modelValue": () => updateSelectedListings(index),
                                        class: "flex-shrink-0 mt-1"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ], 8, _hoisted_62))
                                  }), 128))
                                ])
                              ])
                            ]))
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createVNode(GgmsButton, {
                          styleType: "secondary",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (closeOverlayPanel('listingsPanel')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Cancel ")
                          ]),
                          _: 1
                        }),
                        _createVNode(GgmsButton, { onClick: confirmListings }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(buttonText.value), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 512),
              _createElementVNode("button", {
                onClick: openMergeFieldsModal,
                class: "toolbar-button"
              }, [
                _createVNode(_unref(DocumentTextIcon), { class: "h-5 w-5 text-gray-500" })
              ]),
              _createVNode(GgmsMergeFields, {
                open: isMergeFieldsModalOpen.value,
                isForRichEditor: true,
                specialVariable: specialVariable.value,
                isTemplateTypeEmail: true,
                onAddMergeField: addMergeFieldToTextMessage,
                onCloseModal: closeMergeFieldsModal
              }, null, 8, ["open", "specialVariable"])
            ])
          ]),
          _createVNode(_unref(EditorContent), {
            editor: editor.value,
            modelValue: body.value,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((body).value = $event)),
            class: "editor-content border border-gray-300 rounded-md shadow-sm min-h-48"
          }, null, 8, ["editor", "modelValue"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})